import type {
  ReferralApiResponse,
  ReferralLink,
  ReferralLinkApi,
  ReferralStats,
  ReferralStatsApi,
  ReferredUser,
  ReferredUserApi,
} from "./referrals.types";

export const adaptReferralLink = (response: ReferralApiResponse<ReferralLinkApi>): ReferralLink | null => {
  const payload = response?.data?.data;
  if (!payload) return null;
  return {
    link: payload.link ?? payload.url ?? "",
    code: payload.code ?? payload.referralCode ?? "",
  };
};

export const adaptReferralStats = (response: ReferralApiResponse<ReferralStatsApi>): ReferralStats => {
  const payload = response?.data?.data ?? {};
  return {
    totalReferrals: Number(payload.total_referrals ?? payload.totalReferrals ?? 0),
    totalEarned: Number(payload.total_earned ?? payload.totalEarned ?? 0),
    pending: Number(payload.pending ?? 0),
  };
};

const composeName = (api: ReferredUserApi): string => {
  const first = api.given_name ?? api.firstName ?? "";
  const last = api.family_name ?? api.lastName ?? "";
  const full = `${first} ${last}`.trim();
  return full || api.email || "Usuario";
};

export const adaptReferredUsers = (response: ReferralApiResponse<ReferredUserApi[]>): ReferredUser[] => {
  const list = response?.data?.data;
  if (!Array.isArray(list)) return [];
  return list.map(api => ({
    id: String(api.ID ?? api.id ?? ""),
    email: api.email ?? "",
    fullName: composeName(api),
    createdAt: api.created_at ?? api.createdAt ?? "",
    status: api.status ?? "",
  }));
};
